import { useState } from 'react';
import { IconClose } from '@medifind/icons';
import { ConditionFilter } from '@medifind/search-results';
import { MFLazyLoad } from '@medifind/shared-basic-components';
import { logEventGA4 } from '@medifind/zustand';
import ConditionAvailabilityResult from './ConditionAvailabilityResult';
import styles from './ConditionAvailability.module.scss';

const ConditionAvailability = ({ displayName = '', personId, conditions }) => {
  const [conditionAvailability, setConditionAvailability] = useState(null);

  return (
    <>
      <MFLazyLoad offset={0}>
        <ConditionFilter
          label="Search for your specific condition"
          placeholder={'Enter your health condition'}
          className={styles['condition-availability__input-container']}
          useTypewriterPlaceholder
          showSearchIcon
          classes={{
            inputWrapper: styles['condition-availability__inputWrapper'],
            input: styles['condition-availability__input'],
            filter: styles['condition-availability__filter'],
            icon: styles['condition-availability__icon'],
          }}
          actLikeASelect={false}
          selectValue={conditionAvailability ? { display: conditionAvailability?.codingName, value: conditionAvailability?.projectId } : {}}
          inputIcon={[
            {
              icon: conditionAvailability && <IconClose size="medium" />,
              onClick: (event) => {
                if (event) {
                  setConditionAvailability(null);
                }
              },
              label: 'Clear Condition',
            },
          ]}
          onConditionChange={(event) => {
            if (event?.value) {
              setConditionAvailability({ codingName: event.display, codingType: event.codingType, projectId: event.value });
              logEventGA4('condition_preference', { doctor: personId, condition: event.value });
            }
          }}
        />
      </MFLazyLoad>
      {personId && conditionAvailability && (
        <ConditionAvailabilityResult conditionAvailability={conditionAvailability} conditions={conditions} displayName={displayName} />
      )}
    </>
  );
};

export { ConditionAvailability as default, ConditionAvailability };
